module.exports = __webpack_public_path__ + "static/assets/0e598573e7513953849e7877acfdfd19.png";